module.exports = __webpack_public_path__ + "static/sport/dialogtitle.8f1cd5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/dialogtitle.png
// module id = u5ju
// module chunks = 0